import { render, staticRenderFns } from "./DamageAssessorCaseDetail.vue?vue&type=template&id=47ce9083&scoped=true"
import script from "./DamageAssessorCaseDetail.vue?vue&type=script&lang=js"
export * from "./DamageAssessorCaseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ce9083",
  null
  
)

export default component.exports